export const DEFAULT_ERROR = {
  message: "Der opstod en ukendt fejl",
  authenticationError: "Bruger er ikke autoriseret.",
};
export const FILTER_ERROR = { message: "OBS: Filtre blev ikke læst korrekt" };
export const VEDHAEFTELSE_MISSING_ERROR = {
  message: "OBS: Vedhæftelse kom ikke med",
};
